import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';

/** Immutable View: what the directory resolves for a dossier — its title and the id of its type. */
class SubjectDirectoryEntryView {
	readonly id: number;
	readonly title: string | null;
	readonly typeId: number;

	constructor(payload: SubjectPayload) {
		this.id = payload.id;
		this.title = payload.title;
		this.typeId = payload.type.id;

		Object.freeze(this);
	}
}

export default SubjectDirectoryEntryView;
